import { IDetailsModal } from "./interfaces";
import "./DetailsModal.css";

export const DetailsModal: React.FC<IDetailsModal> = ({ modalProps }) => {
  return <p className="details-modal">{modalProps.content}</p>;
};
